import { render } from "./EeiaSocial.vue?vue&type=template&id=0585fc6c&scoped=true"
import script from "./EeiaSocial.vue?vue&type=script&lang=js"
export * from "./EeiaSocial.vue?vue&type=script&lang=js"

import "./EeiaSocial.vue?vue&type=style&index=0&id=0585fc6c&scoped=true&lang=css"

import exportComponent from "/home/runner/work/eeia-spa/eeia-spa/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0585fc6c"]])

export default __exports__